WiseMetering.Model.SiteTag = WiseMetering.Model.extend({
    urlRoot: '/site_tags',

    siteNames: function() {
        return WiseMetering.zones.sites().reduce((list, site) => {
            if (site.get('tag_ids').includes(this.id)) {
                list.push(site.get('name'));
            }

            return list;
        }, []);
    }
});
